var map = {
	"./360_vignes.jpg": "d5c8",
	"./360_vignes.jpg.astc.ktx": "2db0",
	"./360_vignes.jpg.dxt.ktx": "0a75",
	"./360_vignes.jpg.etc.ktx": "b82b",
	"./360_vignes.jpg.pvr.ktx": "2246",
	"./360_vignes.jpg.webp": "9c8d",
	"./360_vignes_L0.jpg": "565d",
	"./360_vignes_L0.jpg.webp": "8a0f",
	"./Assets_1_base_color.jpg": "8593",
	"./Assets_1_base_color.jpg.astc.ktx": "accd",
	"./Assets_1_base_color.jpg.dxt.ktx": "16a6",
	"./Assets_1_base_color.jpg.etc.ktx": "76b6",
	"./Assets_1_base_color.jpg.pvr.ktx": "1d95",
	"./Assets_1_base_color.jpg.webp": "346f",
	"./Assets_1_base_color_L0.jpg": "68a2",
	"./Assets_1_base_color_L0.jpg.webp": "0dbc",
	"./Assets_2_base_color.jpg": "070f",
	"./Assets_2_base_color.jpg.astc.ktx": "82a8",
	"./Assets_2_base_color.jpg.dxt.ktx": "33b3",
	"./Assets_2_base_color.jpg.etc.ktx": "d102",
	"./Assets_2_base_color.jpg.pvr.ktx": "a8a4",
	"./Assets_2_base_color.jpg.webp": "96a2",
	"./Assets_2_base_color_L0.jpg": "01c8",
	"./Assets_2_base_color_L0.jpg.webp": "d03b",
	"./Assets_3_base_color.jpg": "1b0d",
	"./Assets_3_base_color.jpg.astc.ktx": "ee43",
	"./Assets_3_base_color.jpg.dxt.ktx": "d886",
	"./Assets_3_base_color.jpg.etc.ktx": "d533",
	"./Assets_3_base_color.jpg.pvr.ktx": "5663",
	"./Assets_3_base_color.jpg.webp": "f209",
	"./Assets_3_base_color_L0.jpg": "98ff",
	"./Assets_3_base_color_L0.jpg.webp": "6955",
	"./Assets_4_base_color.jpg": "d2f1",
	"./Assets_4_base_color.jpg.astc.ktx": "4f2a",
	"./Assets_4_base_color.jpg.dxt.ktx": "daf0",
	"./Assets_4_base_color.jpg.etc.ktx": "b17a",
	"./Assets_4_base_color.jpg.pvr.ktx": "8646",
	"./Assets_4_base_color.jpg.webp": "6804",
	"./Assets_4_base_color_L0.jpg": "0e3b",
	"./Assets_4_base_color_L0.jpg.webp": "f65f",
	"./ConcreteFloor_Albedo.jpg": "4377",
	"./ConcreteFloor_Albedo.jpg.webp": "ffff",
	"./ConcreteFloor_Glossiness.jpg": "b830",
	"./ConcreteFloor_Normal.jpg": "3522",
	"./Concrete_Wall_diffuse.jpg": "cb74",
	"./Concrete_Wall_glossiness.jpg": "9767",
	"./Concrete_Wall_normal.jpg": "66b4",
	"./Concrete_Wall_specular.jpg": "16ad",
	"./LM_1_0.jpg": "eec5",
	"./LM_1_0.jpg.webp": "05a0",
	"./LM_1_1.jpg": "6481",
	"./LM_1_1.jpg.webp": "9abe",
	"./LM_1_2.jpg": "c265",
	"./LM_1_2.jpg.webp": "2417",
	"./LM_1_3.jpg": "57b7",
	"./LM_1_3.jpg.webp": "2d8c",
	"./LM_2_0.jpg": "eeee",
	"./LM_2_0.jpg.webp": "38b1",
	"./LM_2_1.jpg": "ae6c",
	"./LM_2_1.jpg.webp": "2584",
	"./LM_2_2.jpg": "6d5a",
	"./LM_2_2.jpg.webp": "3022",
	"./LM_3_0.jpg": "f7a3",
	"./LM_3_0.jpg.webp": "e2c1",
	"./LM_3_1.jpg": "662d",
	"./LM_3_1.jpg.webp": "cbae",
	"./LM_3_2.jpg": "9873",
	"./LM_3_2.jpg.webp": "5f30",
	"./camera_path.bin": "3b15",
	"./frames.glb": "ea74",
	"./lens_reflection.jpg": "d19b",
	"./lens_reflection.jpg.webp": "6b1b",
	"./neons.jpg": "fd9e",
	"./neons.jpg.webp": "12d2",
	"./section_1.glb": "0f92",
	"./section_2.glb": "4901",
	"./section_3.glb": "3278",
	"./stickers_basecolor.jpg": "7f18",
	"./stickers_basecolor.jpg.webp": "05bb",
	"./worms.jpg": "8d44",
	"./worms.jpg.webp": "c636",
	"./wp_all_the_same_color.jpg": "9217",
	"./wp_all_the_same_color.jpg.webp": "c7fd",
	"./wp_concrete_01b2_color.jpg": "9de3",
	"./wp_concrete_01b2_color.jpg.webp": "9c92",
	"./wp_dark_wall_color.jpg": "b710",
	"./wp_dark_wall_color.jpg.webp": "4454",
	"./wp_not_ready_yet_color.jpg": "d84a",
	"./wp_not_ready_yet_color.jpg.webp": "17ef",
	"./wp_painted_concrete_color.jpg": "9fcd",
	"./wp_painted_concrete_color.jpg.webp": "e66e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "de6d";